export const numericBreaks = {
    huge: 1440,
    large: 1024,
    medium: 768,
    small: 480
};
export const breaks = {
    huge: `${numericBreaks.huge}px`,
    large: `${numericBreaks.large}px`,
    medium: `${numericBreaks.medium}px`,
    small: `${numericBreaks.small}px`
};
const less = {
    lessThanHuge: `(max-width: ${numericBreaks.huge - 1}px)`,
    lessThanLarge: `(max-width: ${numericBreaks.large - 1}px)`,
    lessThanMedium: `(max-width: ${numericBreaks.medium - 1}px)`,
    lessThanSmall: `(max-width: ${numericBreaks.small - 1}px)`
};
const great = {
    greaterThanHuge: `(min-width: ${breaks.huge})`,
    greaterThanLarge: `(min-width: ${breaks.large})`,
    greaterThanMedium: `(min-width: ${breaks.medium})`,
    greaterThanSmall: `(min-width: ${breaks.small})`
};
const between = {
    betweenSmallMedium: `${great.greaterThanSmall} and ${less.lessThanMedium}`,
    betweenMediumLarge: `${great.greaterThanMedium} and ${less.lessThanLarge}`,
    betweenLargeHuge: `${great.greaterThanLarge} and ${less.lessThanHuge}`
};
const mediaQueries = Object.assign(Object.assign(Object.assign(Object.assign({}, breaks), less), great), between);
export default mediaQueries;
